import { useState } from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { toast } from "sonner";
import { submitInquiry } from "../lib/api";
import { Send } from "lucide-react";

export function InquiryForm({ prefillProduct }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    requirement_kw: "",
    message: prefillProduct ? `I am interested in: ${prefillProduct}` : "",
  });
  const [submitting, setSubmitting] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Name and phone are required");
      return;
    }
    setSubmitting(true);
    try {
      await submitInquiry(form);
      toast.success(
        form.email
          ? "Inquiry sent! A confirmation email is on its way to you."
          : "Inquiry sent! Our team will call you shortly."
      );
      setForm({ name: "", phone: "", email: "", address: "", requirement_kw: "", message: "" });
    } catch (err) {
      toast.error("Could not send inquiry. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={onSubmit} data-testid="inquiry-form" className="space-y-5">
      <div className="grid md:grid-cols-2 gap-5">
        <div>
          <Label htmlFor="name" className="text-sm font-semibold text-secondary mb-2 block">
            Full Name *
          </Label>
          <Input
            id="name"
            data-testid="inquiry-name"
            value={form.name}
            onChange={set("name")}
            placeholder="Your name"
            className="bg-white border-border rounded-lg h-11"
            required
          />
        </div>
        <div>
          <Label htmlFor="phone" className="text-sm font-semibold text-secondary mb-2 block">
            Phone Number *
          </Label>
          <Input
            id="phone"
            data-testid="inquiry-phone"
            value={form.phone}
            onChange={set("phone")}
            placeholder="+91 98xxx xxxxx"
            className="bg-white border-border rounded-lg h-11"
            required
          />
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-5">
        <div>
          <Label htmlFor="email" className="text-sm font-semibold text-secondary mb-2 block">
            Email <span className="text-muted-foreground font-normal">(for confirmation)</span>
          </Label>
          <Input
            id="email"
            type="email"
            data-testid="inquiry-email"
            value={form.email}
            onChange={set("email")}
            placeholder="you@example.com"
            className="bg-white border-border rounded-lg h-11"
          />
        </div>
        <div>
          <Label htmlFor="address" className="text-sm font-semibold text-secondary mb-2 block">
            Address
          </Label>
          <Input
            id="address"
            data-testid="inquiry-address"
            value={form.address}
            onChange={set("address")}
            placeholder="Installation address"
            className="bg-white border-border rounded-lg h-11"
          />
        </div>
      </div>
      <div>
        <Label htmlFor="kw" className="text-sm font-semibold text-secondary mb-2 block">
          Requirement (in kW)
        </Label>
        <Input
          id="kw"
          data-testid="inquiry-kw"
          value={form.requirement_kw}
          onChange={set("requirement_kw")}
          placeholder="e.g. 3 kW"
          className="bg-white border-border rounded-lg h-11"
        />
      </div>
      <div>
        <Label htmlFor="msg" className="text-sm font-semibold text-secondary mb-2 block">
          Message
        </Label>
        <Textarea
          id="msg"
          data-testid="inquiry-message"
          value={form.message}
          onChange={set("message")}
          placeholder="Tell us about your project..."
          rows={4}
          className="bg-white border-border rounded-lg"
        />
      </div>
      <button
        type="submit"
        data-testid="inquiry-submit"
        disabled={submitting}
        className="inline-flex items-center gap-2 bg-primary text-white hover:bg-orange-600 transition-colors font-medium rounded-full px-8 py-3 disabled:opacity-60"
      >
        <Send className="w-4 h-4" strokeWidth={1.75} />
        {submitting ? "Sending..." : "Send Inquiry"}
      </button>
    </form>
  );
}
